import { UserCookie, WebsiteUserRole } from '@mr-website/schemas';

export type UserProfileSnapshot = {
  firstName: string | null;
  lastName: string | null;
  role: WebsiteUserRole | null;
  email: string | null;
  isMarshallReddickEmployee: boolean;
};

export type RawUserCookie = {
  /** react-cookie auto-parses JSON cookies on the client; next/headers gives the raw string. */
  user?: string | UserCookie;
};

export const LOGGED_OUT_PROFILE_SNAPSHOT: UserProfileSnapshot = {
  firstName: null,
  lastName: null,
  role: null,
  email: null,
  isMarshallReddickEmployee: false,
};

/**
 * Derives the user-profile fields (sourced from the `user` cookie the API
 * sets in GET /profile/user) from raw cookie values. Pure and
 * environment-agnostic so the SSR layout and the client ProfileProvider
 * compute identical snapshots from the same cookie, keeping server HTML and
 * client hydration in agreement.
 */
export function deriveUserProfileSnapshot(raw: RawUserCookie): UserProfileSnapshot {
  let userCookie: UserCookie | undefined;
  if (typeof raw.user === 'string') {
    try {
      userCookie = JSON.parse(raw.user) as UserCookie;
    } catch {
      userCookie = undefined;
    }
  } else {
    userCookie = raw.user;
  }

  if (!userCookie) {
    return LOGGED_OUT_PROFILE_SNAPSHOT;
  }

  return {
    firstName: userCookie.firstName ?? null,
    lastName: userCookie.lastName ?? null,
    role: userCookie.role ?? null,
    email: userCookie.email ?? null,
    isMarshallReddickEmployee: userCookie.email?.endsWith('@marshallreddick.com') ?? false,
  };
}
